import { getModelSchema } from '../api/getDefaultModelSchema';
import { _defaultPrimitiveProp } from '../constants';
import { DeserializeObjectContext } from '../context/DeserializeObjectContext';
import { DeserializeAttributeContext } from '../context/DeserializeAttributeContext';
import { SerializrType_primitive } from '../schema/inner/primitive';
export function deserialize(schemaSource, fromSer) {
    const schema = getModelSchema(schemaSource);
    if (!schema)
        throw 'first argument must be model schema';
    const { parent, constructorArgs, ...ser } = fromSer;
    const deserializeOptions = { parent, constructorArgs };
    return deserializeObjectWithSchema(null, schema, ser, deserializeOptions);
}
export function deserializeObjectWithSchema(parentContext, modelSchema, ser, deserializeOptions = {}) {
    if (ser === null || ser === undefined)
        return ser;
    const context = new DeserializeObjectContext({ ser, deserializeOptions, parentContext, modelSchema });
    let target = deserializeOptions.target;
    let createFromFactory = false;
    if (!target || typeof target !== 'object') {
        createFromFactory = true;
    }
    if (!createFromFactory && target && modelSchema.constructor && target.constructor !== modelSchema.constructor) {
        createFromFactory = true;
        console.log('target object constructor differs - corrected it!', target.constructor, modelSchema.constructor);
    }
    if (createFromFactory) {
        if (modelSchema.constructor && !modelSchema.factory) {
            modelSchema.factory = standardFactory({ Entity: modelSchema.constructor });
        }
        target = modelSchema.factory(context);
    }
    if (!target)
        throw 'No object returned from factory';
    context.target = target;
    deserializePropsWithSchema(context, modelSchema, ser, target);
    return target;
}
function standardFactory({ Entity }) {
    const factory = (context) => {
        const { deserializeOptions } = context;
        const init = {
            parent: deserializeOptions.parent || getParentFromContext(context, deserializeOptions.parentDepth),
            ...deserializeOptions.constructorArgs,
        };
        const entity = new Entity(init);
        return entity;
    };
    return factory;
}
function getParentFromContext(context, parentDepth = 1) {
    let parent = context.parentContext && context.parentContext.target;
    for (let i = 2; i <= parentDepth; i++) {
        parent = parent && parent.parent;
    }
    return parent;
}
export function deserializePropsWithSchema(objectContext, schema, json, target) {
    target.serialized_origin = json;
    if (schema.extends)
        deserializePropsWithSchema(objectContext, schema.extends, json, target);
    Object.keys(schema.props).forEach(propName => deserializePropWithSchema(objectContext, schema, json, target, propName));
    if (schema.afterDeserialize) {
        schema.afterDeserialize({ target, context: objectContext, modelSchema: schema, ser: json });
    }
}
export function deserializePropWithSchema(objectContext, schema, json, target, propName) {
    let propDef = schema.props[propName];
    if (propDef === true)
        propDef = _defaultPrimitiveProp;
    if (propDef === false)
        return;
    deserializePropWithPropDef(objectContext, propDef, json, target, propName);
}
export function deserializePropWithPropDef(objectContext, propDef, json, target, propName) {
    const jsonAttr = propDef.jsonname || propName;
    if (!json.hasOwnProperty(jsonAttr) && !propDef.providesDefault) {
        return;
    }
    const deserialized = deserializeValueWithPropDef(objectContext, propDef, json, target, propName);
    if (deserialized !== Symbol.for('do_not_assign')) {
        target[propName] = deserialized;
    }
}
export function deserializeValueWithPropDef(objectContext, propDef, json, target, propName) {
    const attrName = propDef.jsonname || propName;
    if (!json.hasOwnProperty(attrName) && !propDef.providesDefault) {
        return undefined;
    }
    if (propDef instanceof SerializrType_primitive) {
        // optimize
        return objectContext.ser[attrName];
    }
    const context = new DeserializeAttributeContext({ objectContext, attrName, propName, propDef });
    const newValue = propDef.deserializer(context);
    return newValue;
}
